// extracted by mini-css-extract-plugin
module.exports = {"story":"story--1iUJ6","stretch":"stretch--2ZqlK","loader":"loader--31pEA","float-below":"float-below--5U1Ul stretch--2ZqlK","floatBelow":"float-below--5U1Ul stretch--2ZqlK"};